export default {
  menu: {
    home: "Anasayfa",
    departments: "Departmanlar",
    therapists: "Ekibimize Katılın",
    //services: "Servisler",
    //FAQ: "Sıkça Sorulan Sorular",
    FAQ: "SSS",
    contact: "İletişim",
    about: "Hakkımızda",
    knowledge: "Bilgi Merkezi",
  },
  home: {
    hero: {
      items: [
        {
          title: "Bir nefes al",
          image: require("@/assets/images/bg/11.jpg"),
          subtitle:
            "Gerçek zihinsel değişim, aynı döngülerde kaybolmayı bıraktığınızda başlar. Merkezimizde, bireylerin olumsuz ve işlevsiz düşüncelerini fark edip değiştirerek duygularını ve davranışlarını olumlu yönde dönüştürmelerine destek oluyoruz.",
        },
        {
          title: "Danışmanlık ile şekillenen dönüşüm",
          image: require("@/assets/images/bg/02.jpg"),
          subtitle:
            "Nefes’te sadece dinlemiyoruz. Alıştığınız inançların ötesine geçip, yaşamınızın asıl kaynağını yeniden keşfetmenizi sağlayarak, size yeni ve sınırsız yaşam potansiyellerine ulaşmanız için rehberlik eden bir danışmanlık sunuyoruz. İçinizdeki gücü keşfedin.",
        },
        {
          title: "Haftalar içinde dönüşümünüzü fark edin",
          image: require("@/assets/images/bg/01.jpg"),
          subtitle:
            "Zaman tanımlı ve yapılandırılmış danışmanlık ile derin bir içsel dönüşüm yaşayın. Kalıcı değişimler edinerek hayatınızı dönüştürün. İşlevsiz sohbetlere son vermeye ne dersiniz?",
        },
        {
          title: "Amacımız sizin gelişiminizdir",
          image: require("@/assets/images/bg/05.jpg"),
          subtitle:
            "Seanslar boyunca sizinle iletişimde olacağız. Psikolojik danışmanlarımızın, gereksinimlerinize özgü tasarladıkları çalışmaları pratik ederek hayatınıza doğal bir akışla entegre etmenize destek verecek. Çünkü bizim için geçici rahatlamanız değil, kalıcı dönüşümünüz önemli.",
        },
      ],
      button: "Uzmanla Konuş",
    },
    services: {
      title: "<span class='text-primary'>Sizin</span> için neler yapabiliriz?",
      items: [
        {
          icon: "RiOpenArmLine",
          title: "Yaklaşım Odaklı",
          desc: "Danışmanlık süreci, bireyin yaşadığı durumları daha bilinçli şekilde değerlendirmesine ve kendi problem çözme biçimlerini fark etmesine alan açar.",
        },
        {
          icon: "RiPsychotherapyLine",
          title: "Kişisel Danışmanlık",
          desc: "Danışmanlık süreci, bireyin duygusal, düşünsel ve davranışsal deneyimlerini dikkate alan bir çerçevede ele alınır.",
        },
        {
          icon: "RiUserSmileLine",
          title: "Depresyon",
          desc: "Psikolojik danışmanlık sürecinde, bireyin yaşadığı duygusal durumları ve düşünce süreçlerini daha iyi anlamasına yönelik profesyonel görüşmeler yürütülür.",
        },
        {
          icon: "RiBrain2Line",
          title: "Stres",
          desc: "Psikolojik danışmanlık sürecinde, bireyin stresle ilişkili düşünce ve duygularını anlamasına yönelik profesyonel görüşmeler yürütülür.",
        },
        {
          icon: "RiPulseAiLine",
          title: "Yineleyici ve Zorlayıcı Süreçler",
          desc: "Psikolojik danışmanlık sürecinde, bireyin tekrar eden ve zorlayıcı deneyimlerini anlamasına ve bu süreçleri değerlendirmesine yönelik profesyonel görüşmeler yürütülür.",
        },
        {
          icon: "RiZzzLine",
          title: "Uyku",
          desc: "Psikolojik danışmanlık sürecinde, bireyin uykuya ilişkin yaşadığı deneyimleri ve zorlanmaları anlamasına yönelik profesyonel görüşmeler yürütülür.",
        },
        /*{
          title: "Danışmanlık Eğitimi ",
          desc: Nefes tarafından özelleştirilmiş bilişsel ve davranışsal yöntemler eğitimi ile hem teorik bilginizi güçlendirin, hem de pratik deneyim kazanın.
        {
          title: "Online Danışmanlık ",
          desc: "Psikolojik danışmanlığı her zaman, her yerde; tamamen online ve güvenli bir şekilde alın."
        },*/
      ],
    },
    counter: [
      {
        icon: "client",
        title: "Desteklenen Danışan",
        desc: "Gerçek insanlar, gerçek değişim.",
        value: 7500,
      },
      {
        icon: "session",
        title: "Yapılan Seans",
        desc: "Sürekli destek, gerçek sonuçlar.",
        value: 67000,
      },
      {
        icon: "therapist",
        title: "Eğitilmiş Danışman",
        desc: "Özel yöntemimizle eğitilmiş danışmanlar.",
        value: 1500,
      },
      {
        icon: "avg",
        title: "Ortalama Seans",
        desc: "Ölçülebilir iyileşme için.",
        value: 9,
      },
    ],
    whyUs: {
      title: "Neden <span class='text-primary'>Nefes</span>?",
      mainSubtitle:
        "Klasik terapiden farklı olarak, size bir ekip olarak eşlik ediyoruz. Bilimsel yöntemler, ölçülebilir ilerleme ve 7/24 destek ile gerçek dönüşüm sağlıyoruz.",
      stats: {
        team: "Uzman Ekip Üyesi",
        phases: "Süreç Aşaması",
        units: "Uzmanlık Birimi",
        support: "Destek",
      },
      keyDifference: {
        title: "Tek Bir Uzman Değil, Tam Bir Ekip",
        description:
          "Nefes’te yalnız değilsiniz. 6 kişilik uzman ekibimiz; psikolojik danışman, psikometrist, davranışsal destek uzmanı, koordinatör, süpervizyon sorumlusu ve AI asistan ile danışmanlık süreciniz boyunca koordineli şekilde çalışır.",
      },
      cta: {
        title: "İlk adımı atmaya hazır mısınız?",
        subtitle: "Ücretsiz ön görüşme ile sürecimizi tanıyın.",
      },
      subtitle: `Nefes’te, bireylere yalnızca bir danışmanla görüşme imkânı değil; yapılandırılmış bir psikolojik danışmanlık yaklaşımı sunulmaktadır.<br>
Danışmanlarımız, güncel bilişsel ve davranışsal yaklaşımlar doğrultusunda çalışmakta ve danışanların zihinsel süreçlerini daha iyi anlamalarına eşlik etmektedir.<br>
Bu yaklaşım, klasik bir anlatım sürecinden ibaret değildir.<br>
Psikolojik danışmanlık süreci; bireyin düşünce, duygu ve davranış örüntülerini fark etmesine, bu örüntüler üzerine düşünmesine ve süreci daha bilinçli şekilde değerlendirmesine alan açar.<br>
Görüşmeler, danışmanlık sürecinin yapılandırılmış bir parçası olarak planlanır ve profesyonel çerçevede yürütülür.`,
      items: [
        {
          icon: "team",
          title: "6 Kişilik Ekip Desteği",
          description:
            "Her danışanımıza terapist, psikometrist, koordinatör, davranışsal destek uzmanı, süpervizör ve AI asistan dahil tam bir ekip eşlik eder.",
        },
        {
          icon: "method",
          title: "Probleme Odaklı Yaklaşım",
          description:
            "Geçmişte kaybolmak yerine, bugünkü düşünce ve davranış kalıplarınızı dönüştürmeye odaklanıyoruz. Daha hızlı ve kalıcı sonuçlar.",
        },
        {
          icon: "science",
          title: "DSM-5 Bilimsel Çerçeve",
          description:
            "Yaklaşımımız, Amerikan Psikiyatri Birliği’nin DSM-5 çerçevesi ve güncel bilişsel-davranışçı yaklaşımlar doğrultusunda şekillendirilmiştir.",
        },
        {
          icon: "progress",
          title: "Haftalık Psikometrik Takip",
          description:
            "İlerlemenizi tahminlere değil, haftalık bilimsel testlere dayalı somut verilere dayandırıyoruz. Şeffaf ve ölçülebilir.",
        },
        {
          icon: "ai",
          title: "7/24 AI Asistan Desteği",
          description:
            "Seanslar arası dönemde DSM-5 yöntemleriyle eğitilmiş AI asistanımız yanınızda. Egzersizler, sorular ve destek için.",
        },
        {
          icon: "structured",
          title: "6 Aşamalı Yapılandırılmış Süreç",
          description:
            "Belirsiz ve sonu gelmeyen seanslar yok. Net hedefler, tanımlı aşamalar ve ölçülebilir sonuçlarla ilerleyen profesyonel süreç.",
        },
      ],
    },
    cta: {
      title: "Psikolojik danışmanlık süreci sizin için uygun olabilir mi?",
      subtitle:
        "Psikolojik danışmanlık süreci hakkında bilgi alarak sürecin nasıl ilerlediğini inceleyebilirsiniz.",
      button: "Bir Danışmanla Görüşün",
      whatsappMessage: "Merhaba, danışmanlık seansı almak istiyorum.",
    },
    testimonials: {
      title: "Kullanıcı Deneyimleri",
      subtitle:
        "Her bireyin bir hikayesi vardır. Nefes'te binlerce kişinin hikâyesini yeniden yazmasına yardımcı olduk. Yöntemimiz, danışanlarımızın aktarımlarına dayanarak seansları özenle yapılandırır. İşte danışmanlık seanslarına başladıktan kısa süre sonra danışanlarımızın söyledikleri.",
      list: [
        {
          name: "Defne, 35",
          department: "Depresyon",
          text: "Nefes’i tanıdığımda artık umudum kalmamıştı. Sadece hayatta kalıyor fakat yaşamıyordum. Yapılandırılmış yöntemleri sayesinde tekrar kendimi hissetmeye başladım. Şimdi gerçekten yaşıyorum.",
        },
        {
          name: "Serkan, 31",
          department: "kaygı",
          text: "Kaygı hayatımı ele geçirmişti. Nefes seansları ile birlikte iç huzuruma kavuştum.",
        },
        {
          name: "Yağmur, 27",
          department: "Uyku Sorunları",
          text: "Aylarca doğru düzgün uyuyamadım. Nefes'teki danışmanlık seansları, uyku sorunumun temelini ortaya çıkardı. Artık huzurla uyuyorum.",
        },
        {
          name: "Ela, 29",
          department: " OKB",
          text: "Zihnimi takıntılı düşünceler ele geçirmişti., Nefes'ten aldığım danışmanlık sayesinde zihinsel özgürlüğümü kazandım.",
        },
        {
          name: "Hakan, 27",
          department: "Stres",
          text: "İş stresi beni mahvediyordu. Baskı sadece dışarıdan değil, içeriden de geliyormuş; seanslarımda öğrendim…Şimdi yeniden kontrol bende.",
        },
        {
          name: "Özgür, 34",
          department: "Panik Atak",
          text: "Panik atağın ne olduğunu yaşamayan bilemez. Nefes bana yeniden “nefes almayı” öğretti. Artık atak geldiğinde nasıl baş edeceğimi biliyorum.",
        },
        {
          name: "Seher, 38",
          department: "Gizli Depresyon",
          text: "Dışarıdan gülümsüyordum ama içim boştu. Nefes sayesinde artık rol yapmıyorum. Gerçekten iyileşiyorum.",
        },
        {
          name: "Deniz, 25",
          department: "Özgüven Eksikliği",
          text: "Eskiden hep sessizdim. Nefes bana sesimi bulmayı öğretti. Artık konuşuyorum ve insanlar dinliyor.",
        },
        {
          name: "Furkan, 45",
          department: "Kronik Uykusuzluk",
          text: "Daha önce uyku sorunumla ilgili pek çok yöntem denemiştim. Ama Nefes'teki danışmanlık, sorunun derinine indi. Şimdi doğal olarak uyuyorum bu sayede günü çok daha enerjik yaşayabiliyorum.",
        },
        {
          name: "Umut, 28",
          department: "Amaçsızlık",
          text: "Ne istediğimi bilmiyordum. Ama Nefes sayesinde içimdeki bilinmeyen parçaları keşfettim. Artık sadece var olmuyorum, yaşıyorum.",
        },
      ],
    },
  },
  homePage: {
    hero: {
      badge: "Profesyonel Psikolojik Danışmanlık Hizmetleri",
      title: "Bir Nefes Al",
      subtitle:
        "Zihinsel süreçleri fark etmek, kişinin kendini daha yakından tanımasına alan açar. Merkezimizde, bireylerin düşünce, duygu ve davranışlarını anlamalarına yönelik psikolojik danışmanlık hizmeti verilmektedir.",
      servicesButton: "Hizmetlerimiz",
    },
    promo: {
      badge: "Bilimsel Yaklaşım",
      title: "Sürecimizi Keşfedin",
      description:
        "Uzman danışman kadrosu ve yapılandırılmış psikolojik danışmanlık süreci.",
      experts: "Uzman",
      units: "Birim",
      phases: "Aşama",
      button: "Sürecimizi İnceleyin",
    },
  },
  departmentsPage: {
    header: {
      title: "Departmanlar",
      subtitle: "Profesyonel psikolojik destek alanlarımız",
    },
    cta: {
      title: "Profesyonel Destek Almaya Hazır mısınız?",
      description:
        "Uzman danışmanlarımızla hemen iletişime geçin ve ilk adımı atın.",
      whatsappButton: "WhatsApp ile Ulaşın",
    },
  },
  quizPopup: {
    title: "Kendinizi Nasıl Hissediyorsunuz?",
    description:
      "Ücretsiz psikolojik değerlendirme testimizle ruh sağlığınızı keşfedin. Sadece 2 dakika sürer ve size özel öneriler sunar.",
    features: {
      scienceBased: "Bilimsel temelli",
      confidential: "100% Gizli",
      duration: "Sadece 2 dakika",
    },
    startButton: "Teste Başla",
    laterButton: "Daha sonra",
    note: "DSM-5 kriterleri baz alınarak hazırlanmıştır",
  },
  faqComponent: {
    stats: {
      questions: "Soru",
      support: "Destek",
      fast: "Hızlı",
      response: "Yanıt",
    },
    noResults: "Sonuç bulunamadı",
    noResultsHint: "Farklı anahtar kelimeler deneyin",
    loadMore: "Daha Fazla Yükle",
  },
  servicesComponent: {
    badge: "Hizmetlerimiz",
  },
  whyUsComponent: {
    badge: "Neden Biz?",
  },
  aiSection: {
    badge: "Yapay Zeka Destekli",
    title: "Nefes AI Danışmanlık Asistanı",
    subtitle:
      "Güncel bilimsel yaklaşımlar doğrultusunda tasarlanmış, kişiselleştirilmiş yapay zeka destekli danışmanlık asistanınız",
    cta: "AI Özelliklerini Keşfedin",
    features: {
      dsm5: {
        title: "DSM-5 Temelli",
        description:
          "DSM-5 çerçevesi doğrultusunda yapılandırılmış yapay zeka destekli asistan",
      },
      selfTrain: {
        title: "Günlük Öğrenme",
        description:
          "Danışan ilerleme verilerini analiz ederek her gün kendini eğitir",
      },
      personalized: {
        title: "Kişiye Özel",
        description:
          "Her danışanın profiline ve ihtiyaçlarına göre önerilerini kişiselleştirir",
      },
      mobile: {
        title: "7/24 Erişim",
        description: "Özel mobil uygulama ile her an erişilebilir",
      },
      documentation: {
        title: "Tam Dokümantasyon",
        description:
          "Klinik görüşmeler, seans notları, terapist notları ve egzersizlere erişim",
      },
    },
    stats: {
      availability: "Erişilebilirlik",
      methodology: "Metodoloji",
      powered: "Destekli",
    },
  },
  comparison: {
    badge: "Yöntem Karşılaştırması",
    title: "Neden Nefes Yöntemi Farklı?",
    subtitle:
      "Klasik terapi yaklaşımları ile Nefes'in bilimsel yöntemini karşılaştırın",
    intro:
      "Nefes'te problemin kökenine değil, problemin kendisine ve çözümüne odaklanıyoruz. Bilimsel kanıtlara dayalı yaklaşımımız, psikometrik değerlendirmelerle desteklenerek ölçülebilir sonuçlar sunuyor.",
    classical: {
      title: "Klasik Terapi",
      label: "Geleneksel",
      items: [
        "Problemin kökenine ve geçmişe uzun süre odaklanma",
        "Belirsiz seans sayısı ve süre",
        "Öznel değerlendirmeler ve ölçülemeyen ilerleme",
        "Tek terapist ile sınırlı bakış açısı",
        "Seanslar arası destek yok",
        "Standart yaklaşım, kişiselleştirme sınırlı",
      ],
    },
    nefes: {
      title: "Nefes Yöntemi",
      label: "Bilimsel",
      items: [
        "Probleme ve çözüme odaklanma - hızlı sonuçlar",
        "Yapılandırılmış, zaman tanımlı süreç",
        "Haftalık psikometrik testlerle ölçülebilir ilerleme",
        "Ekip yaklaşımı ile çok boyutlu değerlendirme",
        "7/24 AI asistan desteği",
        "Kişiye özel, DSM-5 temelli danışmanlık planı",
      ],
    },
    keyDifference: {
      title: "Temel Farkımız: Probleme Odaklanma",
      description:
        "Klasik yaklaşımlarda zaman zaman “Bu problem neden var?” sorusu üzerinde uzun süre durulabilir. Nefes’te ise süreci, “Bu durumu nasıl ele alabilir ve nasıl ilerleyebiliriz?” sorusu çerçevesinde yapılandırıyoruz. Geçmişi anlamak önemlidir; ancak asıl gelişim, bugünkü düşünce ve davranış örüntülerini fark ederek bunlar üzerinde çalışmakla mümkün olur. Bilimsel temelli, çözüm odaklı yaklaşımlar; hedefleri netleştirmeye, süreci yapılandırmaya ve ilerlemeyi daha yakından takip etmeye yardımcı olur.",
    },
    scientificBasis: {
      title: "Bilimsel Temellerimiz",
      items: [
        {
          title: "DSM-5 Kriterleri",
          description:
            "Amerikan Psikiyatri Birliği'nin en güncel tanı kriterleri",
        },
        {
          title: "Bilişsel Davranışçı Yaklaşım",
          description:
            "Kanıta dayalı, etkinliği bilimsel olarak kanıtlanmış yöntemler",
        },
        {
          title: "Psikometrik Ölçümler",
          description:
            "Geçerliliği ve güvenilirliği kanıtlanmış standart testler",
        },
        {
          title: "Ekip Süpervizyonu",
          description: "Multidisipliner ekip ile çok boyutlu değerlendirme",
        },
      ],
    },
    psychometric: {
      title: "Psikometrik Değerlendirme Birimimiz",
      description:
        "Psikometrik birimimiz, DSM-5 kriterlerine dayalı standart testler kullanarak danışanların psikolojik durumunu bilimsel yöntemlerle değerlendirir. Haftalık testlerle ilerlemeniz ölçülür ve terapistlerinizle paylaşılır. Bu sayede danışmanlık süreciniz tamamen ölçülebilir ve şeffaf hale gelir.",
      tags: [
        "DSM-5 Temelli Testler",
        "Haftalık İlerleme Takibi",
        "Bilimsel Raporlama",
        "Terapist Desteği",
        "Nesnel Değerlendirme",
      ],
    },
  },
  aiFeatures: {
    secure: "Güvenli",
    hero: {
      badge: "Yapay Zeka Destekli Danışmanlık",
      title: "Nefes AI ile Danışmanlık Deneyiminizi Güçlendirin",
      subtitle:
        "DSM-5 yöntemleriyle eğitilmiş, kişiselleştirilmiş yapay zeka asistanımız danışmanlık sürecinizi destekler ve her an yanınızdadır.",
    },
    features: {
      badge: "Özellikler",
      sectionTitle: "Gelişmiş Yapay Zeka Özellikleri",
      sectionSubtitle:
        "Psikolojik danışmanlık sürecinizi destekleyen akıllı özellikler",
      dsm5: {
        title: "DSM-5 Eğitimli Yöntemler",
        description:
          "Yapay zeka asistanımız, en güncel DSM-5 psikolojik danışmanlık yöntemleriyle eğitilmiştir. Bilimsel temelli yaklaşımlarla danışmanlık sürecinizi destekler.",
      },
      selfTrain: {
        title: "Günlük Öz-Eğitim",
        description:
          "Her gün danışan ilerleme verilerini analiz ederek kendini geliştiren yapay zeka, sürekli öğrenen ve uyum sağlayan bir destek sunar.",
      },
      personalized: {
        title: "Danışan Profiline Özel",
        description:
          "Her danışanın benzersiz profiline göre kişiselleştirilen öneriler ve rehberlik ile size özel bir danışmanlık deneyimi yaşayın.",
      },
      mobile: {
        title: "7/24 Mobil Uygulama Erişimi",
        description:
          "Özel mobil uygulamamız aracılığıyla her an, her yerden AI asistanınıza erişin. Seanslar arası destek artık cebinizde.",
      },
      documentation: {
        title: "Tam Doküman Erişimi",
        description:
          "Klinik görüşmeler, seans notları, danışman notları ve tüm egzersizlere tek bir yerden erişim imkanı.",
      },
    },
    howItWorks: {
      badge: "Nasıl Çalışır?",
      title: "AI Destekli Danışmanlık Süreci",
      subtitle:
        "Yapay zeka asistanımız danışmanlık sürecinizin her aşamasında yanınızda.",
      steps: [
        {
          title: "Profil Oluşturma",
          description:
            "İlk görüşmede danışmanlık gereksinimleriniz ve hedefleriniz belirlenir.",
        },
        {
          title: "AI Eşleştirmesi",
          description:
            "Yapay zeka, profilinize göre kişiselleştirilmiş bir destek planı oluşturur.",
        },
        {
          title: "Sürekli Destek",
          description:
            "Seanslar arası dönemde AI asistanınız egzersizleri takip eder ve rehberlik sunar.",
        },
        {
          title: "İlerleme Takibi",
          description:
            "Danışmanlık süreciniz boyunca gelişiminiz analiz edilir ve raporlanır.",
        },
      ],
    },
    benefits: {
      badge: "Avantajlar",
      title: "AI Destekli Danışmanlığın Faydaları",
      subtitle: "Geleneksel danışmanlığın yapay zeka ile güçlendirilmiş hali.",
      items: [
        {
          title: "Kesintisiz Destek",
          description:
            "7/24 erişilebilir AI asistanı ile seanslar arası dönemde bile destek alın.",
        },
        {
          title: "Kişiselleştirilmiş Deneyim",
          description:
            "Profilinize özel egzersizler ve önerilerle daha etkili bir danışmanlık süreci.",
        },
        {
          title: "Bilimsel Yaklaşım",
          description:
            "DSM-5 yöntemleriyle eğitilmiş AI ile kanıta dayalı danışmanlık desteği.",
        },
        {
          title: "İlerleme Görünürlüğü",
          description:
            "Detaylı raporlar ve analizlerle danışmanlık sürecinizdeki ilerlemenizi takip edin.",
        },
      ],
    },
    cta: {
      title: "AI Destekli Danışmanlığı Deneyimleyin",
      subtitle:
        "Yapay zeka destekli danışmanlık hizmetimiz hakkında bilgi almak için bizimle iletişime geçin.",
      button: "Ücretsiz Ön Görüşme",
      whatsappMessage:
        "Merhaba, AI destekli danışmanlık hizmeti hakkında bilgi almak istiyorum.",
    },
  },
  knowledgeArticle: {
    trustBadges: {
      dsm5Based: "Temelli",
      evidenceBased: "Kanıta Dayalı",
      expertVerified: "Uzman Onaylı",
    },
    sidebar: {
      aboutTitle: "Nefes Psikoloji Hakkında",
      services: {
        onlineCounseling: "Online psikolojik danışmanlık",
        cbtApproaches: "Bilişsel davranışçı yaklaşımlar",
        personalizedPlans: "Kişiselleştirilmiş destek planları",
        whatsappSupport: "7/24 WhatsApp desteği",
      },
      quickContact: "Hızlı İletişim",
    },
    authorBox: {
      title: "Hakkında Yazar",
      teamName: "Nefes Psikoloji Uzman Ekibi",
      credentials: "Sertifikalı Psikolojik Danışmanlar",
      description:
        "Nefes Psikoloji ekibi, bilişsel davranışçı yaklaşımlar ve modern psikolojik yöntemler konusunda uzmanlaşmış, deneyimli psikolojik danışmanlardan oluşmaktadır. Amacımız, kanıta dayalı yöntemlerle bireylerin yaşam kalitesini artırmak ve psikolojik sağlıklarını desteklemektir.",
      contactButton: "Uzmanlarımızla İletişime Geçin",
    },
    cta: {
      title: "Profesyonel Destek Almak İster misiniz?",
      description:
        "Uzman psikologlarımızla ücretsiz ön görüşme için hemen iletişime geçin.",
      whatsappButton: "WhatsApp ile İletişime Geç",
      freeBadge: "İlk danışmanlık görüşmeniz ücretsiz!",
    },
    related: {
      title: "Diğer Uzman Makalelerimiz",
      subtitle: "Nefes Psikoloji ekibinden daha fazla içerik keşfedin",
      authorLabel: "Nefes Uzman Ekibi",
    },
  },
  faq: {
    title: "Sıkça Sorulan Sorular",
    subtitle:
      "Hizmetlerimiz, yöntemimiz ve danışmanlarımız hakkında en çok sorulan soruları burada yanıtlıyoruz.",
    items: [
      {
        question: "Nefes’i diğer danışmanlık merkezlerinden ayıran nedir?",
        answer:
          "Nefes, tüm danışmanlarını kendi özel yöntemiyle eğitir. Sadece bir danışman atamıyoruz; yapılandırılmış bir sistem sunuyoruz ve seanslar arası süreci aktif olarak takip ediyoruz.",
      },
      {
        question:
          "Sizden psikolojik danışmanlık aldığımda gerçekten faydasını görebilir miyim? Ne kadar zamanda fayda alırım?",
        answer:
          "Evet. Yöntemimiz kısa sürede gözle görülür değişim alacağınız bir süreçtir.  Çoğu danışanımız ilk bir kaç seansta önemli bir gelişme kaydeder.",
      },
      {
        question: "Danışmanlarınız lisanslı mı?",
        answer:
          "Kesinlikle. Nefes psikolojik danışmanlarının hepsi lisanslı profesyonellerdir ve ayrıca kurumumuzca özel olarak eğitilerek en güncel bilişsel ve davranışsal yöntemlerin danışmanlık uygulamalarında uzmanlaşmışlardır. Hem profesyonel hem de felsefi olarak Nefes ile uyumludurlar.",
      },
      {
        question: "Hangi psikolojik sorunları ele alıyorsunuz?",
        answer:
          "Depresyon, kaygı, OKB ve uyku sorunlarını ele alıyoruz. Yeme bozukluğu, bipolar bozukluk ve  kanser psikolojisi açılacak diğer departmanlarımız arasında. Yöntemimiz esnektir ve birçok psikolojik zorluğa destek vermek üzere uyarlanabilir.",
      },
      {
        question: "Seanslar online mı yoksa yüz yüze mi?",
        answer:
          "Tüm danışmanlık seanslarımız online olarak yürütülür. Bu, yoğun programı olan ya da bulunduğu bölgede kaliteli danışmanlığa erişimi olmayan bireyler için büyük avantaj sağlar.",
      },
      {
        question: "Her seans ne kadar sürer?",
        answer: "Bir seans genellikle 45 ila 50 dakika sürer.",
      },
      {
        question: "Kaç seans gereklidir?",
        answer:
          "Çoğu danışanımız birkaç seans içinde büyük ilerleme gösterir. Ancak gerekli seans sayısı kişisel durumunuza göre değişebilir. Sizin için özel olarak yapılandırılır.",
      },
      {
        question: "Psikolojik danışmanımı nasıl seçebilirim?",
        answer:
          "Danışmanınızı, ihtiyaçlarınız ve danışmanlık almanız gereken yöntemi dikkate alarak sizin için en etkin sonucu elde edecek şekilde biz belirliyoruz.",
      },
      {
        question: "İlk seansı nasıl ayarlayabilirim?",
        answer:
          "Web sitemiz veya WhatsApp üzerinden bizimle iletişime geçebilirsiniz. Size ücretsiz bir ön görüşme sunulacaktır.",
      },
      {
        question: "İlaç reçete ediyor musunuz?",
        answer:
          "Hayır. İlaç reçetesi verilmez; yöntemimiz zihinsel yeniden yapılanmaya dayanır.",
      },
      {
        question: "Anonim olarak danışmanlık alabilir miyim?",
        answer:
          "Evet. İsterseniz anonim olarak seansa katılabilirsiniz. Bilgileriniz %100 gizli tutulur.",
      },
      {
        question: "Seanslar hangi dilde gerçekleşiyor?",
        answer:
          "Seanslar Türkçe, Farsça ve İngilizce dillerinde yapılabilir. Tercihinize göre dil seçebilirsiniz.",
      },
      {
        question: "Bu yöntemin bana uygun olup olmadığını nasıl anlarım?",
        answer:
          "Ücretsiz ön görüşme sırasında ihtiyaçlarınız değerlendirilir ve nasıl yardımcı olabileceğimiz açıklanır.",
      },
      {
        question:
          "Resmi bir tanı almamış olsam da yine de sizden danışmanlık alabilir miyim?",
        answer:
          "Kesinlikle. Birçok danışanımız resmi bir tanıya sahip değildir ama yine de büyük fayda sağlar.",
      },
      {
        question: "İş stresi veya tükenmişlik konusunda yardımcı olur musunuz?",
        answer:
          "Evet. İş stresi, tükenmişlik ve duygusal yorgunluk en sık çalıştığımız konulardandır.",
      },
      {
        question: "Birkaç seanstan sonra ilerleme görmezsem ne olur?",
        answer:
          "Geri bildiriminiz bizim için önemlidir. Gerekirse dosyanız yeniden değerlendirilir, danışman değiştirilebilir.",
      },
      {
        question: "Karar vermeden önce biriyle konuşabilir miyim?",
        answer:
          "Elbette. 'Danışmanla Görüş' butonuna tıklayarak ücretsiz ve yükümlülüksüz bir görüşme başlatabilirsiniz.",
      },
      {
        question: "Danışmanlık çocuklar veya gençler için uygun mu?",
        answer:
          "Şu anda Nefes, yalnızca 18 yaş ve üzeri bireylerle çalışmaktadır.",
      },
      {
        question: "Bilgilerim gizli tutulacak mı?",
        answer:
          "Evet. Tüm bilgileriniz en yüksek gizlilik standartlarında saklanır ve asla izniniz olmadan paylaşılmaz.",
      },
      {
        question: "Bilgilerime kimler erişebilir?",
        answer:
          "Yalnızca sürecinizde yer alan lisanslı danışmanlar verilerinize erişebilir ve bu veriler yalnızca danışmanlık amacıyla kullanılır.",
      },
      {
        question: "Danışmanlık sürecim izleniyor mu?",
        answer:
          "Evet. Danışmanlık süreciniz sistem tarafından sürekli izlenir.",
      },
      {
        question: "Danışmanlık tamamlandıktan sonra takip ediliyor muyum?",
        answer:
          "Evet. Danışmanlık sonrası belli aralıklarla sizinle iletişime geçerek sürecin kalıcılığı sağlanır.",
      },
      {
        question: "Nefes danışmanı nasıl olabilirim?",
        answer:
          "Web sitemizden başvurabilirsiniz. Kabul edildiğinizde özel eğitim programımıza dahil olursunuz.",
      },
      {
        question: "Yeni danışmanlardan ne tür nitelikler bekliyorsunuz?",
        answer:
          "Psikolog ve klinik psikologlar ile çalışıyoruz. Bizim eğitimimizi alarak bütüncül olarak danışanlarımıza sunabilmelerini bekliyoruz.",
      },
      {
        question: "Uluslararası danışmanlarla çalışıyor musunuz?",
        answer:
          "Evet. Türkçe, Farsça veya İngilizce bilen dünya çapındaki profesyonelleri memnuniyetle kabul ediyoruz.",
      },
    ],
  },
  footer: {
    tagline:
      "Nefes’te, psikolojik danışmanlık; bireysel deneyimleri ve zihinsel süreçleri anlamaya odaklanan profesyonel bir çerçeve içerisinde ele alınır. Danışmanlarımız, etik ve mesleki standartlar doğrultusunda yapılandırılmış bir danışmanlık süreci sunar.",
    information: "Aydınlatma Metni",
    privacy: "Gizlilik Politikası",
    copyright:
      "Nefes Psikolojik Danışmanlık Eğitim ve Yazılım Hizmetleri Anonim Şirketi.",
    address:
      "İzzetpaşaçiftliği Mahallesi, Yeniyol Caddesi No:12 Asımoğlu İşhanı, Kat:5, D:8 Şişli/ İstanbul",
    phone: "+90 531 011 51 51",
  },
  contactus: {
    title: "Bize Ulaşın",
    subtitle: "Sorularınız mı var? Size yardımcı olmaktan mutluluk duyarız.",
    form_title: "İletişim formu",
    register: "Gönder",
    message: "Mesajınız",
    success: "Mesajınız başarıyla gönderildi.",
  },
  departments: {
    title: "Uzmanlık Alanlarımız",
    subtitle: "Nefes’in danışmanları hangi konularda size yardımcı olabilir?",
    more: "Daha Fazla",
    items: [
      {
        image: require("@/assets/images/bg/depression.jpg"),
        icon: "depression",
        title: "Depresyon",
        desc: "Depresyonla başa çıkmayı öğrenin ve hayatınıza dengeyi geri kazandırın. Yöntemimiz, olumsuz düşünce kalıplarınızı fark etmenize yardımcı olur ve zorlayıcı zamanlarda bile kendinizi yeniden toparlamanızı sağlar.",
      },
      {
        image: require("@/assets/images/bg/anger.jpg"),
        icon: "anxiety",
        title: "Kaygı ve Korku",
        desc: "Kaygı ve korkunuzla başa çıkmayı öğrenin, zihinsel huzurunuzu yeniden keşfedin. Yöntemimiz, kaygınızı yönetmenize ve sağlıklı düşünce alışkanlıkları geliştirmenize yardımcı olur.",
      },
      {
        image: require("@/assets/images/bg/ocd.jpg"),
        icon: "ocd",
        title: "Takıntılar",
        desc: "Takıntılı düşünceler ve zorlayıcı davranışlarla başa çıkmayı keşfedin. Danışmanlarımız, OKB döngülerini kırmak ve zihinsel rahatlama sağlamak için size etkili teknikler sunar.",
      },
      {
        image: require("@/assets/images/bg/sleep.jpg"),
        icon: "sleep",
        title: "Uyku Bozuklukları",
        desc: "Uykusuzluk ve düzensiz uyku alışkanlıklarıyla başa çıkmanın yollarını öğrenin. Danışmanlarımız, sağlıklı uyku düzeni oluşturmanız ve dinlendirici bir uyku için etkili yöntemleri sizinle paylaşır.",
      },
      {
        image: require("@/assets/images/bg/psychotherapy.jpg"),
        icon: "psychotherapy",
        title: "Psikoterapi",
        desc: "Bireysel psikoterapi ile kendinizi keşfedin ve içsel dönüşümünüzü başlatın. Danışmanlarımız, kişisel gelişiminizi desteklemek ve yaşam kalitenizi artırmak için size rehberlik eder.",
      },
      {
        image: require("@/assets/images/bg/psychometric.jpg"),
        icon: "psychometric",
        title: "Psikometrik Testler",
        desc: "DSM-5 temelli psikolojik testler ile danışanların durumunu değerlendiriyoruz. Terapistlere tanı sürecinde destek sağlıyor ve haftalık testlerle danışan gelişimini takip ediyoruz.",
      },
      {
        image: require("@/assets/images/bg/behavioral-support.jpg"),
        icon: "behavioral-support",
        title: "Davranışsal Destek",
        desc: "Danışanların günlük egzersizlerini düzenli olarak yapmalarına yardımcı oluyoruz. Egzersizler hakkındaki sorularını yanıtlıyor ve günlük takip ile motivasyonlarını destekliyoruz.",
      },
    ],
  },
  departmentsContent: {
    depression: {
      title: "Depresyon",
      subtitle: "Bu alanda psikolojik danışmanlık sunulmaktadır.",
      description:
        "Depresyon, bireyin duygusal durumu, enerji düzeyi, motivasyonu ve günlük yaşam deneyimleri üzerinde etkili olabilen bir durum olarak ele alınmaktadır. Bu bölümde, depresyona ilişkin yaşantıların daha iyi anlaşılmasına yönelik psikolojik danışmanlık sürecine genel bir çerçeve sunulmaktadır.",
      symptoms: [
        "Sürekli yorgunluk ve motivasyon azalması",
        "Önceden ilgi duyulan etkinliklere karşı isteksizlik",
        "Suçluluk veya değersizlik düşünceleri",
        "Dikkat, odaklanma veya hafıza ile ilgili zorlanmalar",
        "Uyku düzeni veya iştah değişiklikleri",
        "Boşluk hissi, sık ağlama isteği veya tekrarlayan olumsuz düşünceler",
        "Günlük kararları almakta zorlanma",
      ],
      method:
        "Nefes’te sunulan psikolojik danışmanlık süreci, bilişsel ve davranışsal yaklaşımlar çerçevesinde yapılandırılmış görüşmelerden oluşur. Bu süreç, bireyin düşünce ve davranış örüntülerini fark etmesine ve kendi deneyimlerini daha bilinçli şekilde değerlendirmesine alan açar.",
    },
    /*stress: {
      title: "Stres",
      subtitle: "Kronik gerilim günlük yaşamın bir parçası olmamalı...",
      description:
        "Stres modern yaşamın bir parçasıdır; ancak yönetilemeyen stres, kararlarımızı, ilişkilerimizi ve sağlığımızı bozabilir. Bu bölümde, gizli stres tetikleyicilerini tespit ediyor, tepki mekanizmalarını yeniden inşa ediyor ve etkili başa çıkma stratejileri öğretiyoruz.",
      symptoms: [
        "Sürekli baskı hissi ve gevşeyememe",
        "Sinirlilik veya sürekli öfke",
        "Zihinsel huzursuzluk veya odaklanma zorluğu",
        "Açıklanamayan fiziksel rahatsızlıklar (baş ağrısı, mide ağrısı vb.)",
        "Sosyal etkileşimlerden sonra aşırı yorgunluk",
      ],
      method:
        "Bilişsel kalıpları analiz ediyor, psikolojik tetikleyicileri belirliyor ve yüksek baskılı durumları yönetmek için pratik araçlar sunuyoruz. Terapi süreci, düzenli takiplerle desteklenir.",
    },*/
    anxiety: {
      title: "Kaygı ve Korku",
      subtitle: "Zihin kontrolünü kaybettiğinde, beden de zarar görür...",
      description:
        "Kaygı ve korku, bazı bireylerde birlikte deneyimlenebilen ve zihinsel, fiziksel ve sosyal yaşam üzerinde etkileri olabilen duygusal durumlar olarak ele alınmaktadır. Bu bölümde, kaygı ve korkuya ilişkin yaşantıların anlaşılmasına yönelik psikolojik danışmanlık sürecine genel bir çerçeve sunulmaktadır.",
      symptoms: [
        "Sürekli endişe hali ve olumsuz senaryolar üzerine yoğun düşünme",
        "Fiziksel gerginlik, kalp çarpıntısı veya nefes alma ile ilgili zorlanmalar",
        "Huzursuzluk hissi ve açıklanması zor korkular",
        "Sosyal ya da mesleki sorumluluklardan kaçınma eğilimi",
      ],
      method:
        "Nefes’te sunulan psikolojik danışmanlık süreci, bilişsel ve davranışsal yaklaşımlar çerçevesinde yapılandırılmış görüşmelerden oluşur. Bu süreç, bireyin kaygıya ilişkin düşünce ve duygusal deneyimlerini fark etmesine ve bu yaşantıları daha bilinçli şekilde değerlendirmesine alan açar.",
    },
    ocd: {
      title: "OKB",
      subtitle: "Bırakamayan bir zihin nazikçe yönlendirilmelidir...",
      description:
        "OKB, bazı bireylerde tekrar eden düşünceler ve zorlayıcı davranışlarla birlikte deneyimlenebilen bir durum olarak ele alınmaktadır. Bu bölümde, OKB’ye ilişkin yaşantıların anlaşılmasına yönelik psikolojik danışmanlık sürecine genel bir çerçeve sunulmaktadır.",
      symptoms: [
        "Tekrarlayan ve istem dışı düşünceler",
        "Belirli davranışlar yapılmadığında yoğun kaygı hissi",
        "Kaygıyı azaltmaya yönelik tekrarlayıcı davranışlar",
        "Bu düşünce ve davranışların mantıklı bulunmamasına rağmen durdurmakta zorlanma",
      ],
      method:
        "Nefes’te sunulan psikolojik danışmanlık süreci, OKB kapsamında yaşanan düşünce ve davranış deneyimlerinin ele alındığı yapılandırılmış görüşmelerden oluşur. Bu süreçte, bireyin yaşantılarını daha iyi anlamasına ve bu deneyimleri değerlendirmesine yönelik profesyonel bir çerçeve sunulmaktadır.",
    },
    sleep: {
      title: "Uyku Bozuklukları",
      subtitle: "Yorgun bir beden yalnızca daha fazla hata üretir...",
      description:
        "Uykuya ilişkin zorlanmalar, bazı bireylerde zihinsel ve duygusal durumlarla birlikte deneyimlenebilmektedir. Bu bölümde, uyku ile ilgili yaşantıların anlaşılmasına yönelik psikolojik danışmanlık sürecine genel bir çerçeve sunulmaktadır.",
      symptoms: [
        "Uzun süre uyuyamama ya da uykuya dalmakta zorlanma",
        "Gece boyunca sık uyanma veya hafif ve huzursuz uyku",
        "Yeterli süre uyunmasına rağmen dinlenmiş hissetmeme",
        "Uykuya dalmayı zorlaştıran yoğun ve tekrarlayıcı düşünceler",
      ],
      method:
        "Nefes’te sunulan psikolojik danışmanlık süreci, uykuya ilişkin yaşanan zorlanmaların ele alındığı yapılandırılmış görüşmelerden oluşur. Bu süreçte, bireyin uykuya dair düşünce ve duygusal deneyimlerini fark etmesine ve bu yaşantıları değerlendirmesine yönelik profesyonel bir çerçeve sunulmaktadır.",
    },
    counseling: {
      title: "Psikoterapi",
      subtitle: "İçsel yolculuğunuzda yanınızdayız...",
      description:
        "Psikolojik danışmanlık, bireyin düşünce, duygu ve deneyimlerini daha iyi anlamasına yönelik profesyonel bir görüşme süreci olarak ele alınmaktadır. Bu bölümde, psikolojik danışmanlık sürecinin genel çerçevesi ve nasıl ilerlediğine dair bilgilere yer verilmektedir.",
      symptoms: [
        "Genel bir memnuniyetsizlik hissi veya yaşamdan yeterince tatmin alamama",
        "İlişkilerde tekrar eden zorlanmalar",
        "Kendini tanıma ve yaşam deneyimlerini anlama ihtiyacı",
        "Geçmiş deneyimlerin günlük yaşantı üzerindeki etkileriyle ilgili zorlanmalar",
        "Kişisel gelişim ve potansiyelini keşfetmeye yönelik ilgi",
        "Yaşam geçiş dönemlerinde yaşanan zorluklar (kariyer, ilişki, ebeveynlik gibi)",
        "Duygusal dengeyle ilgili iniş çıkışlar",
      ],
      method:
        "Nefes’te sunulan psikolojik danışmanlık süreci, bilişsel ve davranışsal yaklaşımlar çerçevesinde yapılandırılmış görüşmelerden oluşur. Bu süreç, bireyin düşünce, duygu ve davranış deneyimlerini daha iyi anlamasına ve bu yaşantıları değerlendirmesine yönelik profesyonel bir çerçeve sunar.",
    },
    psychometric: {
      title: "Psikometrik Testler",
      subtitle: "Bilimsel değerlendirme ile doğru tanı ve gelişim takibi...",
      description:
        "Psikometrik birim, DSM-5 kriterlerine dayalı psikolojik testler uygulayarak danışanların durumunu bilimsel yöntemlerle değerlendirmektedir. Bu birim, terapistlere tanı sürecinde profesyonel destek sağlamakta ve danışanların haftalık testlerle gelişimini takip etmektedir.",
      symptoms: [
        "Psikolojik durumun objektif değerlendirmesi ihtiyacı",
        "Terapi sürecinde ilerlemenin ölçülmesi",
        "DSM-5 kriterlerine göre tanı desteği",
        "Haftalık gelişim takibi ve raporlama",
        "Terapist için detaylı değerlendirme raporu",
        "Bireysel güçlü ve zayıf yönlerin belirlenmesi",
      ],
      method:
        "Psikometrik birimimiz, DSM-5 temelli standart testler kullanarak danışanların psikolojik durumunu değerlendirmektedir. Haftalık uygulanan testlerle danışanın gelişimi izlenmekte ve bu veriler terapistlerle paylaşılarak tanı ve terapi sürecine destek sağlanmaktadır.",
    },
    behavioralSupport: {
      title: "Davranışsal Destek",
      subtitle: "Günlük egzersizlerinizde yanınızdayız...",
      description:
        "Davranışsal Destek birimi, danışanların terapistleri tarafından verilen günlük egzersizleri düzenli olarak yapmalarına yardımcı olmaktadır. Bu birim, egzersizler hakkındaki soruları yanıtlamakta ve günlük takip ile danışanların motivasyonunu desteklemektedir.",
      symptoms: [
        "Günlük egzersizleri düzenli uygulamada zorlanma",
        "Egzersizlerin nasıl yapılacağına dair soru işaretleri",
        "Motivasyon düşüklüğü veya isteksizlik",
        "Egzersizleri bir rutine oturtma ihtiyacı",
        "Danışmanlık sürecinde düzenli destek ve takip ihtiyacı",
        "Ev ödevlerini tamamlamada yaşanan zorluklar",
      ],
      method:
        "Davranışsal Destek Birimimiz, danışanlarla günlük iletişim kurarak önerilen egzersizlerin düzenli şekilde uygulanmasını destekler. Egzersizlere ilişkin soruları yanıtlar, sürece dair yönlendirme sunar ve düzenli takip ile danışmanlık sürecinde sürekliliğin korunmasına katkı sağlar.",
    },
  },
  therapists: {
    title: "Danışman Ağına Katılın",
    description:
      "<span style='font-weight:bolder;font-size:24px;'>Nefes’te</span> danışman olarak nasıl çalışabileceğinizi ve eğitim sürecimizi öğrenin.",
    howWeWork: {
      title: "Danışmanlarla Nasıl Çalışıyoruz?",
      subtitle:
        "Nefes’te, danışmanlarla iş birliği; kurumsal değerlerimiz, etik ilkeler ve mesleki standartlar doğrultusunda yürütülür. Danışmanlık süreci, belirlenen çalışma çerçevesi içerisinde yapılandırılmış şekilde ele alınır.",
      steps: [
        {
          title: "Başvuru",
          text: "Psikolojik danışmanlar, online başvuru formu aracılığıyla Nefes ile iş birliği sürecine başvurabilir. Başvuru sürecinde, adayların eğitim geçmişi ve mesleki deneyimlerine dair genel bilgiler değerlendirilir.",
        },
        {
          title: "Bilgilendirme Oturumu",
          text: "Ön değerlendirme sonrası uygun bulunan danışmanlar, yöntemimizi ve beklentilerimizi tanıttığımız kısa bir çevrim içi bilgilendirme oturumuna davet edilirler. Bu oturum, karşılıklı sorular ve netleştirmeler için de bir fırsat sunar.",
        },
        {
          title:
            "Bilişsel ve Davranışsal Yaklaşımlara Dayalı Danışmanlık Eğitimi",
          text: "Çalışma çerçevemize uygunluk gösteren danışmanlar, Nefes tarafından belirlenen bilişsel ve davranışsal yaklaşımlar doğrultusunda düzenlenen danışmanlık eğitimine katılır. Bu eğitim, kuramsal içeriklerin yanı sıra uygulamaya yönelik paylaşımları da kapsar.",
        },
        {
          title: "Sertifika ve İş Birliği",
          text: "Eğitim sürecini tamamlayan danışmanlar, ilgili belgeyi alarak Nefes danışman ağına Dahil edilir. Bu aşamadan sonra, danışmanlık faaliyetleri belirlenen profesyonel ve etik çerçeve içerisinde yürütülür.",
        },
      ],
    },
    form0: {
      title: "Kayıt Formu",
      first_name: "Ad",
      last_name: "Soyad",
      birth_date: "Doğum Tarihi",
      gender: "Cinsiyet",
      male: "Erkek",
      female: "Kadın",
      marriage_status: "Medeni Durum",
      single: "Bekar",
      married: "Evli",
      degree: "Mezuniyet Derecesi",
      university: "Üniversite",
      graduate_date: "Mezuniyet Tarihi",
      experience: "Deneyim",
      phone: "Telefon",
      email: "E-posta",
      email_code: "E-posta Doğrulama Kodu",
      email_code_placeholder: "6 haneli kodu giriniz",
      verify: "Doğrula",
      verified: "Doğrulandı",
      send_code: "Kod Gönder",
      job_history: "İş Geçmişi",
      city: "Şehir",
      address: "Adres",
      submit: "Kaydol",
      completed: "Kayıt Tamamlandı",
      agreement_label: "Sözleşme şartlarını okudum ve kabul ediyorum.",
      agreement_accept: "Kabul Ediyorum",
      back_home: "Ana Sayfaya Dön",
    },
    validation: {
      first_name_min: "İsim en az 2 karakter olmalıdır",
      last_name_min: "Soyisim en az 2 karakter olmalıdır",
      degree_required: "Mezuniyet derecesi gereklidir",
      email_required: "Lütfen e-posta adresinizi girin ve doğrulayın",
      city_required: "Şehir alanı gereklidir",
      address_required: "Adres alanı gereklidir",
      birthdate_required: "Doğum Tarihi alanı gereklidir alanı gereklidir",
      email_invalid: "e-posta adresi geçersiz",
      phone_invalid: "telefon numarası geçersiz",
      agreement_required: "Sözleşme kabul etmeniz gerekiyor.",
    },
    messages: {
      whatsapp_instruction:
        "Kayıt yönergesi için lütfen bu WhatsApp numarasına mesaj gönderin.",
      registration_success: "Kayıt başarıyla tamamlandı.",
      email_invalid: "Geçerli bir e-posta adresi girin.",
      email_code_failed: "Kod gönderilemedi. Lütfen tekrar deneyin.",
      verification_failed: "Doğrulama başarısız. Lütfen tekrar deneyin.",
      send_whatsapp: "WhatsApp ile Mesaj Gönder",
    },
    form1: {
      title: "New Therapist Application",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      city: "City",
      specialization: "Specialization",
      experience: "Years of Experience",
      motivation: "Why do you want to work with Nafas?",
      submit: "Submit",
    },
    form2: {
      title: "Training Participation & Contract",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      trainingGroup: "Select Training Group",
      timeSlot: "Preferred Time Slot",
      consent: "I agree to the terms and training program.",
      signature: "Signature",
      signaturePlaceholder: "Type or draw your signature",
      submit: "Confirm and Join",
    },
  },
  delete: {
    delete_account: "Hesabı Sil",
    sub_title: "Hesabınızı silmek istediğinizden emin misiniz?",
    phone_number: "Telefon Numarası",
    title: "mobil uygulama hesabını sil",
    subtitle: "Bu formu kullanarak mobil uygulama hesabınızı silebilirsiniz.",
    otp: "6 haneli OTP kodu",
    otp_placeholder: "6 haneli OTP kodunu girin",
    send_otp: "OTP kodu gönder",
    otp_sent: "OTP kodu gönderildi",
    account_deleted: "Hesap silme isteği gönderildi.",
  },
  room: {
    loading_please_wait: "Yükleniyor, lütfen bekleyin...",
    room_not_found:
      "oda verilerini almada hata oluştu,<br>lütfen destek ekibiyle iletişime geçin",
    session_not_started: "Oturum henüz başlamadı.",
    session_will_start_at: "Oturum şu tarihte başlayacak",
    session_expired: "Oturum süresi doldu.",
    session_ended_at: "Oturum sona erdi",
    first_name: "Ad",
    last_name: "Soyad",
    code: "Kodu",
    birth_date: "Doğum Tarihi",
    gender: "Cinsiyet",
    marriage: "evlilik",
    patient_info: "Danışan Bilgileri",
    enter_answer: "Yanıtınızı girin",
    save: "Kaydet",
    save_success: "Form başarıyla kaydedildi.",
    patient_recent_forms: "Danışanın Son Formları",
    session_form: "Toplantı Formu",
  },
  about: {
    title: "Nefes Psikoloji Hakkında",
    paragraph1: `
    <strong class="text-primary">Nefes Psikoloji</strong>, psikolojik danışmanlık hizmetlerini <strong>profesyonel</strong>
    ve <strong>profesyonel</strong> etik bir çerçevede sunan bir danışmanlık merkezidir.
    Merkezimizde, <strong>bireylerin düşünce</strong>, duygu ve davranışlarını daha iyi anlamalarına yönelik yapılandırılmış psikolojik danışmanlık görüşmeleri yürütülmektedir.`,
    paragraph2: `Terapi süreçlerimizde görev alan <strong>uzman psikologlarımız</strong>,
    yalnızca akademik donanımlarıyla değil;
    aynı zamanda <strong>çok boyutlu bakış açılarını geliştiren bilimsel süpervizyonlar</strong> sayesinde her danışana özgü, derinlikli ve etik değerlere dayalı bir yaklaşım sunar. Bu sayede danışanlarımız, kendilerine özel, saygılı ve bütüncül bir terapi süreci deneyimler.`,
    paragraph3: `<strong class="text-primary">Nefes Psikoloji</strong>, yalnızca <strong>yetişkin bireylerle</strong> çalışmakta; geçmişten gelen ya da günlük yaşamda
    aniden ortaya çıkan, içsel dünyanın derinliklerine uzanan çok katmanlı zorluklarla başa çıkmalarına destek olmaktadır.
    Bu süreçte kullanılan tüm yaklaşımlar, <strong>güçlü bir kuramsal temele</strong> dayanır ve her danışanın yaşam öyküsüne duyulan derin saygıyla şekillenir.`,
    paragraph4: `Bizler, her bireyin kendi içsel gücüne ulaşabileceği <strong>güvenli ve destekleyici bir alan</strong> yaratmayı temel önceliğimiz olarak görüyoruz.
    <br /> Çünkü inanıyoruz ki:<strong>Doğru yöntemlerle ve doğru uzmanlarla yürütülen her terapi süreci, yaşamda kalıcı ve anlamlı değişimlerin kapısını aralar.</strong>`,
    paragraph5: `Haydi… Şimdi birlikte derin bir Nefes alalım.`,
  },
  certificates: {
    items: [
      {
        title: "Müşteri Memnuniyeti ve Şikayetleri Yönetim Sistemi",
        image: require("@/assets/images/certs/10002.png"),
      },
      {
        title: "Kurumsal Risk Yönetim Sistemi",
        image: require("@/assets/images/certs/31000.png"),
      },
      {
        title: "İş Sağlığı ve Güvenliği Yönetim Sistemi",
        image: require("@/assets/images/certs/45001.png"),
      },
      {
        title: "Bilgi Güvenliği Yönetim Sistemi",
        image: require("@/assets/images/certs/27001.png"),
      },
      {
        title: "Kalite Yönetim Sistemi",
        image: require("@/assets/images/certs/9001.png"),
      },
    ],
  },
  invoice: {
    title: "Fatura",
    subtitle: "Faturanızla ilgili detaylar aşağıda yer almaktadır.",
    payment_confirmed_title: "Ödeme Onaylandı",
    payment_confirmed_subtitle: "Ödeme işleminiz başarıyla tamamlandı.",
    payment_failed_title: "Ödeme Başarısız",
    payment_failed_subtitle:
      "Ödeme işleminiz başarısız oldu. Lütfen tekrar deneyin.",
    loading: "Yükleniyor...",
    details: "Fatura Detayları",
    code: "Fatura Kodu",
    date: "Fatura Tarihi",
    total: "Toplam Tutar",
    kdv: "KDV Tutarı",
    invoice_items: "Fatura Kalemleri",
    invoice_payment: "Fatura Ödeme",
  },
  app: {
    title: "açılış başvurusu",
    message: "Uygulamayı açmaya çalışıyorum...",
    subtitle: "Uygulama açılmazsa uygulama mağazasına yönlendirileceksiniz.",
    download_manually: "Veya manuel olarak indirin:",
    app_required: "Mobil Uygulama Gerekli",
    desktop_message: "Lütfen bu sayfayı mobil cihazınızda açın.",
    app_not_found: "Uygulama Bulunamadı",
    redirect_to_store: "Uygulama Mağazasına Yönlendiriliyor...",
    redirect_to_app: "Uygulamaya Yönlendiriliyor...",
    app_opened: "Uygulama Açıldı!",
  },
  quiz: {
    title: "KİŞİSELLEŞTİRİLMİŞ DANIŞMANLIK SÜRECİ",
    subtitle:
      "Danışmanlık süreci, bireyin ihtiyaçları ve beklentileri dikkate alınarak yapılandırılır.",
    male: "Erkek",
    female: "Kadın",
    what_is_your_age: "Yaşınız nedir?",
    using_age: "Yaşınızı yalnızca planınızı kişiselleştirmek için kullanıyoruz",
    what_is_your_problem: "Sorununuz nedir?",
    anxiety: "Kaygı",
    depression: "Depresyon",
    sleep: "Uyku",
    OCD: "OKB",
    continue: "Devam Et",
    disorders: [
      {
        title: "anxiety",
        questions: [
          "Sık sık endişeli hisseder misiniz?",
          "Küçük şeyler için bile fazla kaygılandığınız olur mu?",
          "Gelecekle ilgili çok fazla düşünür müsünüz?",
          "Kötü bir şey olacakmış gibi hissettiğiniz olur mu?",
          "Kaygı yüzünden uyumakta zorlanır mısınız?",
          "Kalp çarpıntısı veya terleme yaşar mısınız?",
          "Kaygı nedeniyle başınız ağrır mı?",
          "Kaygı yüzünden odaklanmakta zorlanır mısınız?",
          "Toplum içinde gergin hisseder misiniz?",
          "Kaygınız günlük işlerinizi etkiler mi?",
          "Kaygı nedeniyle sürekli bir şeyleri kontrol eder misiniz?",
          "Kaygı sizi sosyal ilişkilerden uzaklaştırır mı?",
          "Kaygı yüzünden hızlı nefes aldığınız olur mu?",
          "Kaygı yüzünden iş veya okul performansınız düşer mi?",
          "Kaygı nedeniyle karar vermekte zorlanır mısınız?",
        ],
      },
      {
        title: "depression",
        questions: [
          "Son zamanlarda sık sık üzgün hissediyor musunuz?",
          "Hayattan zevk almakta zorlanıyor musunuz?",
          "Kendinizi değersiz hissediyor musunuz?",
          "Sık sık ağlama isteğiniz oluyor mu?",
          "Kendinizi yalnız hissediyor musunuz?",
          "Eskiden keyif aldığınız şeyler artık keyif vermiyor mu?",
          "Yorgunluk nedeniyle hiçbir şey yapmak istemediğiniz oluyor mu?",
          "Gelecek konusunda umutsuz musunuz?",
          "Kendinizi suçlu hissediyor musunuz?",
          "Konsantre olmakta zorlanıyor musunuz?",
          "Uykunuzda değişiklik oldu mu?",
          "İştahınızda değişiklik oldu mu?",
          "Karar vermekte zorlanıyor musunuz?",
          "Hayatın anlamsız olduğunu düşündüğünüz oluyor mu?",
          "Kendinizi sürekli kötü bir ruh halinde buluyor musunuz?",
          "Kendinize zarar verme düşünceleriniz oldu mu?",
        ],
      },
      {
        title: "sleep",
        questions: [
          "Uyumakta zorlanıyor musunuz?",
          "Gece sık sık uyanır mısınız?",
          "Sabah çok erken uyanıyor musunuz?",
          "Uykudan yorgun kalkar mısınız?",
          "Gün içinde uykulu hisseder misiniz?",
          "Uykusuzluk nedeniyle sinirli olur musunuz?",
          "Uykusuzluk işinizi veya okulunuzu etkiler mi?",
          "Telefon ya da televizyon yüzünden uykuya geç dalar mısınız?",
          "Kabuslar yüzünden uykunuz bölünür mü?",
          "Uykusuzluk nedeniyle dikkatinizi toplamakta zorlanır mısınız?",
          "Uykusuzluk sosyal ilişkilerinizi etkiler mi?",
          "Uyku için ilaç veya bitkisel destek kullanır mısınız?",
          "Uykuya dalmak için çok uzun süre bekler misiniz?",
          "Uykusuzluk sizi mutsuz eder mi?",
          "Günlük hayatınızı uykusuzluk olumsuz etkiler mi?",
        ],
      },
      {
        title: "OCD",
        questions: [
          "Ellerinizi sık sık yıkama ihtiyacı hisseder misiniz?",
          "Kapı veya ocağı tekrar tekrar kontrol eder misiniz?",
          "Zihninizden gitmeyen rahatsız edici düşünceler olur mu?",
          "Bir işi yaparken belli bir düzeni takip etmek zorunda hisseder misiniz?",
          "Düşüncelerinizi susturmakta zorlanır mısınız?",
          "Kirlenme korkusu nedeniyle bazı yerlere gitmekten kaçınır mısınız?",
          "Bir şeyleri simetrik veya düzenli yapmak zorunda hisseder misiniz?",
          "Aklınıza gelen düşünceleri uğursuz olarak görür müsünüz?",
          "Bazı şeyleri yapmazsanız kötü bir şey olacakmış gibi hisseder misiniz?",
          "Sürekli temizlik yapma ihtiyacı duyar mısınız?",
          "Bazı düşünceler sizi çok rahatsız eder mi?",
          "Bir şeyleri saymadan rahat edemez misiniz?",
          "OKB davranışları günlük hayatınızı etkiler mi?",
          "Bu düşünceleri ve davranışları kontrol etmekte zorlanır mısınız?",
          "Bu durumdan dolayı mutsuz olur musunuz?",
        ],
      },
    ],
    scientific_title: "Nefes, bilimsel uygulamalar kullanılarak geliştirildi",
    scientific_subtitle:
      "Nefes, değerlendirme ve müdahalede DSM-5-TR tanı ölçütlerini (American Psychiatric Association) kullanır. Müdahale planlarımız kanıta dayalı kılavuzlarla uyumludur ve gerektiğinde ICD-11 kodlarıyla eşleştirilir.",
    what_is_your_first_name: "<span class='text-primary'>Adınız</span> nedir?",
    what_is_your_first_name_sub: "Lütfen gerçek adınızı girin",
    summary_of_profile: "profilinizin özeti",
    level: "seviyesi",
    processing: "Cevaplarınız değerlendiriliyor",
    anxiety_levels: {
      very_low: "En az ya da hiç",
      low: "Sınırda Kaygı",
      light: "Hafif düzey Kaygı",
      medium: "Orta düzey Kaygı",
      high: "Şiddetli düzey Kaygı",
      very_high: "Aşırı düzey Kaygı",
    },
    depression_levels: {
      very_low: "En az ya da hiç",
      low: "Hafif düzey Depresyon",
      light: "Orta düzey Depresyon",
      medium: "Şiddetli düzey  Depresyon",
      high: "Aşırı düzey Depresyon",
    },
    sleep_levels: {
      very_low: "En az ya da hiç",
      low: "Sınırda Uyku Bozukluğu",
      light: "Hafif  Uyku Bozukluğu",
      medium: "Orta Uyku Bozukluğu",
      high: "Şiddetli Uyku Bozukluğu",
      very_high: "Aşırı Uyku Bozukluğu",
    },
    OCD_levels: {
      very_low: "En az ya da hiç",
      low: "Sınırda OKB",
      light: "Hafif düzey OKB",
      medium: "Orta düzey OKB",
      high: "Şiddetli düzey OKB",
      very_high: "Aşırı düzey OKB",
    },
    well_beings: {
      very_low: "Yüksek",
      low: "Yüksek",
      light: "Orta",
      medium: "Orta",
      high: "Düşük",
      very_high: "Düşük",
    },
    now: "Şimdi",
    your_goal: "Hedefiniz",
    well_being: "İyi olma hali",
    get_free_consultation: "Ücretsiz danışmanlık istiyorum",
    free_consultation: "<span class='text-primary'>Ücretsiz</span> danışmanlık",
    consulation_subtitle:
      "Adınızı ve cep telefonu numaranızı girmeniz halinde, terapistlerimiz size ücretsiz kısa bir yönlendirici danışmanlık verebilir.",
    enter_phone_number: "Telefon numaranızı girin",
    enter_name: "Adınızı girin",
    without_nefes_title:
      "<span class='text-primary'>Nefes</span> olmadan hayat nasıl olabilirdi?",
    without_nefes: [
      "İnsanların yanında gülüyorsun ama aklın hiç susmuyor.",
      "“Geçer” diyorsun ama hep geri dönüyor.",
      "Uyku bile artık dinlendirmiyor.",
      "Eskisi gibi hissetmiyorsun.",
      "Küçük şeyler bile fazla gelmeye başlıyor.",
      "Sakin olmanın nasıl bir şey olduğunu unutuyorsun.",
      "“İyiyim.” diyorsun ama içten içe bir şeylerin yolunda olmadığını biliyorsun.",
    ],
    with_nefes_title:
      "<span class='text-primary'>Nefes</span> size hangi konularda yardımcı olabilir?",
    with_nefes: [
      "Yüzeyin altındaki asıl sebepleri anlamanı sağlarız.",
      "Hissettiklerinin aslında anlaşılır ve çözülür olduğunu gösteririz.",
      "Zihnini susturmak değil, sakinleştirmek için araçlar veririz.",
      "Daha iyi uyumanı, daha net düşünmeni sağlarız.",
      "Enerjini ve motivasyonunu geri kazandırırız.",
      "Kendinle yeniden bağ kurmana yardımcı oluruz.",
      "Sonsuz sohbet değil; yapılandırılmış, sonuç odaklı terapi sunarız.",
      "Düşüncelerinle savaşmak yerine onlarla barışmanı öğretiriz.",
      "Yeniden nefes alabileceğin bir alan açarız — adım adım.",
      "Gerçekten “Artık iyiyim.” diyene kadar yanında oluruz.",
    ],
    call_me: "ücretsiz arama talep et",
    final_step_title: "Teşekkür ederiz.",
    final_step_subtitle3: "Artık iyileşme yolculuğunuz başladı.",
    final_step_subtitle1:
      "Koordinasyon ekibimiz, <strong>1–2 iş günü (08:00–17:00)</strong> içinde sizinle iletişime geçerek lisanslı terapistlerimizden biriyle ücretsiz görüşmenizi planlayacaktır.",
    final_step_subtitle2:
      "<strong class='text-primary'>Nefes ekibi</strong>, profesyonel ve kişisel destek sağlamak için tam eğitimli ve sürece adanmıştır.",
    bi_nefes_al:
      "Kısa süre içinde sizinle iletişime geçeceğiz. O zamana kadar — bir nefes alın.",
    back_to_home: "Ana sayfaya dön",
    your_current_status: "Mevcut durumunuz",
    you_are_good:
      "<strong class='text-primary'>İyi gidiyorsunuz.</strong><br />Yine de, cevapladığınız standart soruların ortaya çıkaramadığı, ancak yaşamınızı olumsuz etkileyebilecek bir “görünmeyen duygusal yük” olabilir mi?<br />Bu soruyu birlikte netleştirelim. 10 dakikalık ücretsiz kısa görüşme için numaranızı bırakın.",
  },
  knowledge: {
    title: "Bilgi Merkezi",
    subtitle:
      "Psikoloji ve psikolojik danışmanlık alanlarında bilgilendirici ve uzman içerikler.",
    searchPlaceholder: "Makale ara...",
    allCategories: "Tüm Kategoriler",
    readMore: "Devamını Oku",
    minRead: "dk okuma",
    views: "görüntüleme",
    noArticles: "Makale bulunamadı",
    noArticlesDesc: "Yakında yeni içerikler için tekrar kontrol edin.",
    loading: "Yükleniyor...",
    share: "Paylaş",
    tableOfContents: "İçindekiler",
    tags: "Etiketler",
    relatedArticles: "İlgili Makaleler",
    notFound: "Makale bulunamadı",
    notFoundDesc: "Aradığınız makale mevcut değil veya kaldırılmış.",
    backToArticles: "Bilgi Merkezine Dön",
  },
  ourProcess: {
    hero: {
      badge: "Süreç Mimarisi",
      title: "Nefes Psikoloji'de Bilimsel Süreç Kurgusu ve Uzmanlık Desteği",
      subtitle:
        "Nefes'te danışmanlık süreciniz tek bir uzmanla sınırlı kalmaz. Altı farklı uzmanlık alanından oluşan entegre ekibimiz, sizin için kapsamlı bir destek ağı oluşturur.",
      scroll: "Keşfet",
      learnMore: "Daha Fazla Bilgi",
    },
    nav: {
      intro: "Tanıtım",
      team: "Ekip",
      departments: "Birimler",
      journey: "Yolculuk",
      contact: "İletişim",
    },
    intro: {
      eyebrow: "Nefes Psikoloji",
      title: "Nefes Psikoloji'ye Hoş Geldiniz",
      content:
        "Psikolojik destek sürecine ilk adımı atmanın büyük ve bazen zor bir karar olabileceğini biliyoruz. Bu yolda yalnız olmadığınızdan emin olmanızı sağlamak için buradayız. Gerçek ilerlemenin yalnızca bir uzmana dayanarak değil, şefkatli ve profesyonel bir ekibin tam desteğiyle mümkün olduğuna inanıyoruz. Nefes'te sadece bir 'danışan' değilsiniz; siz, altı kişilik bir ekip tarafından desteklenen kendi psikolojik sürecinizin etkin bir parçasısınız.",
      stats: {
        team: "Uzman Ekip Üyesi",
        departments: "Uzmanlık Birimi",
        phases: "Süreç Aşaması",
      },
      features: {
        team: {
          title: "6 Kişilik Uzman Ekip",
          desc: "Her aşamada koordineli çalışan profesyoneller",
        },
        scientific: {
          title: "Bilimsel Yaklaşım",
          desc: "Kanıta dayalı yöntemler ve psikometrik testler",
        },
        support: {
          title: "Sürekli Destek",
          desc: "Seanslar arası takip ve rehberlik",
        },
      },
    },
    team: {
      label: "Psikolojik Destek Ekibi",
      title: "Her Adımda Yanınızdayız",
      desc: "Altı farklı uzmanlık alanından profesyoneller, danışmanlık sürecinizin her aşamasında koordineli çalışır.",
      imageCaption: "Profesyonel Destek Ekibimiz",
      members: {
        counselor: {
          title: "Uzman Psikolojik Danışman",
          role: "Bireysel Seanslar",
          desc: "Haftalık bireysel seanslarınızı yürütür, bilişsel ve davranışsal yaklaşımlarla size rehberlik eder.",
        },
        clinical: {
          title: "Klinik Psikolog",
          role: "Genel Değerlendirici",
          desc: "İlk adımınız. Ruhsal durumunuzu bütüncül bir bakış açısıyla değerlendirir ve yönlendirir.",
        },
        psychometrist: {
          title: "Uzman Psikometrist",
          role: "Test Uygulayıcı ve Analist",
          desc: "Geçerliliği ve güvenilirliği kanıtlanmış psikometrik testleri uygular ve analiz eder.",
        },
        coordinator: {
          title: "Süreç Koordinatörü",
          role: "Planlama ve Koordinasyon",
          desc: "İlk günden itibaren yanınızda. Randevularınızı planlar ve ekip içi koordinasyonu sağlar.",
        },
        assistant: {
          title: "Asistan Psikolog",
          role: "Uygulama Destekçisi",
          desc: "Seans içgörülerini günlük yaşama aktarmanıza yardımcı olur, pratik destek sağlar.",
        },
        supervisor: {
          title: "Klinik Süpervizör",
          role: "Bilimsel Gözlemci",
          desc: "Sürecin bilimsel ve etik standartlara uygunluğunu denetler, ekibi yönlendirir.",
        },
      },
    },
    departments: {
      label: "Uzmanlık Birimleri",
      title: "Özelleşmiş Destek Alanları",
      desc: "Her danışanın ihtiyacına göre uzmanlaşmış birimlerimiz, en etkili desteği sunmak için koordineli çalışır.",
      items: {
        depression: {
          title: "Depresyon ve Motivasyon Düşüklüğü",
          desc: "Duygudurum sorunları ve motivasyon kaybı için kapsamlı destek",
        },
        anxiety: {
          title: "Kaygı, Stres ve Öfke Kontrolü",
          desc: "Anksiyete ve stres yönetimi teknikleri ile duygusal denge",
        },
        ocd: {
          title: "Takıntılı Düşünce ve Davranışlar (OKB)",
          desc: "Obsesif kompulsif belirtiler için özel destek programı",
        },
        sleep: {
          title: "Uyku Bozuklukları",
          desc: "Uyku sorunlarının kök nedenine yönelik çalışma",
        },
        personality: {
          title: "Kişilik Yapısı ile İlgili Sorunlar",
          desc: "Kişilik gelişimi ve ilişki kalıpları üzerine destek",
        },
        trauma: {
          title: "Travmalar ve Çocukluk Dönemi Süreçleri",
          desc: "Geçmiş deneyimlerin işlenmesi ve dönüştürülmesi",
        },
        psychometric: {
          title: "Psikometrik Değerlendirme Birimi",
          desc: "Kapsamlı psikolojik test, analiz ve raporlama",
        },
      },
    },
    journey: {
      label: "Danışan Yolculuğu",
      title: "Adım Adım Süreç",
      desc: "Bilimsel yöntemlerle tasarlanmış, her adımı ölçülebilir ve şeffaf altı aşamalı süreç",
      phases: {
        assessment: {
          label: "Aşama 1",
          title: "Değerlendirme ve Tanı Aşaması",
          desc: "Kapsamlı bir değerlendirme ile mevcut durumunuz ve ihtiyaçlarınız belirlenir.",
          steps: [
            "Kapsamlı klinik görüşme",
            "Psikolojik, bilişsel, duygusal değerlendirme",
            "Psikometri Birimi'ne yönlendirme",
            "Aile ve çevre analizi",
          ],
        },
        testing: {
          label: "Aşama 2",
          title: "Psikometrik Testler",
          desc: "Belirti değerlendirmesi ve kapsamlı kişilik analizi yapılır.",
          steps: [
            "Belirti Değerlendirmesi (kaygı, uyku, depresyon, enerji, odaklanma)",
            "Kapsamlı Kişilik Analizi (MCMI Testi)",
            "Sonuçların detaylı analizi",
            "Bireysel profil oluşturma",
          ],
        },
        mapping: {
          label: "Aşama 3",
          title: "Kişisel Destek Haritası",
          desc: "İki değerlendirme aracı ile kişiselleştirilmiş destek haritanız oluşturulur.",
          steps: [
            "Belirti ve kişilik verilerinin entegrasyonu",
            "Bireysel güçlü yönlerin belirlenmesi",
            "Odaklanılacak alanların tespiti",
            "Özelleştirilmiş yaklaşım planı",
          ],
        },
        diagnosis: {
          label: "Aşama 4",
          title: "Nihai Tanı ve Plan Paylaşımı",
          desc: "Bilimsel temelli değerlendirme sonuçları ve destek planınız sizinle paylaşılır.",
          steps: [
            "Bilimsel temelli nihai değerlendirme",
            "Sorunun türü ve şiddetinin belirlenmesi",
            "Psikolojik altyapı analizi",
            "Özel destek planının sunumu",
          ],
        },
        support: {
          label: "Aşama 5",
          title: "Uzmanlık Temelli Destek Başlangıcı",
          desc: "Doğru uzmanla eşleştirilir ve yapılandırılmış seanslarınız başlar.",
          steps: [
            "Uygun uzmanla eşleştirme",
            "Bireysel seans programının oluşturulması",
            "Hedef odaklı çalışma başlangıcı",
            "Düzenli ilerleme değerlendirmesi",
          ],
        },
        followup: {
          label: "Aşama 6",
          title: "Süreç Takibi ve Seans Dışı Destek",
          desc: "Haftalık psikometrik takip ve seanslar arası destek ile kazanımlarınız pekiştirilir.",
          steps: [
            "Haftalık psikometrik takip",
            "Asistan psikolog ile seanslar arası destek",
            "Kazanımların günlük yaşama entegrasyonu",
            "Sürekli ilerleme izleme",
          ],
        },
      },
    },
    cta: {
      label: "Başlayın",
      title: "İletişime geçin, yolculuğunuza birlikte başlayalım",
      desc: "Uzman ekibimiz sizinle ilk görüşmeyi planlamak için hazır. Ücretsiz ön değerlendirme için hemen iletişime geçin.",
      freeConsultation: "Ücretsiz Ön Görüşme",
      privacyGuarantee: "Gizlilik Garantisi",
      button: "WhatsApp ile İletişime Geçin",
    },
  },
  aboutPage: {
    header: {
      badge: "Hakkımızda",
      title: "Nefes Psikoloji",
      subtitle: "İçsel dönüşüm ve farkındalık yolculuğunuzda yanınızdayız",
    },
    sections: {
      whoWeAre: {
        badge: "Biz Kimiz",
        title: "Profesyonel Psikolojik Danışmanlık Merkezi",
      },
      values: {
        badge: "Değerlerimiz",
        title: "Neden Nefes?",
      },
      expertTeam: {
        badge: "Uzman Kadro",
        title: "Deneyimli Psikologlar",
      },
      approach: {
        badge: "Yaklaşımımız",
        title: "Yetişkin Bireylere Özel",
      },
      mission: {
        badge: "Misyonumuz",
        title: "Güvenli ve Destekleyici Alan",
      },
    },
    values: {
      scientific: {
        title: "Bilimsel Yaklaşım",
        desc: "En güncel bilişsel ve davranışçı terapi yöntemlerini kullanıyoruz",
      },
      personal: {
        title: "Kişisel Yaklaşım",
        desc: "Her danışana özel, saygılı ve bütüncül bir terapi süreci sunuyoruz",
      },
      confidentiality: {
        title: "Gizlilik",
        desc: "Tüm görüşmeleriniz tamamen gizli ve güvende tutulur",
      },
      lasting: {
        title: "Kalıcı Sonuçlar",
        desc: "Geçici rahatlama değil, kalıcı dönüşüm için çalışıyoruz",
      },
    },
    cta: {
      desc: "Uzman danışmanlarımızla hemen iletişime geçin",
      button: "WhatsApp ile İletişime Geçin",
    },
  },
  teamPage: {
    header: {
      title: "Ekibimiz",
      subtitle: "Deneyimli ve uzman kadromuzla tanışın",
    },
    categories: {
      supervisor: "Süpervizör",
      therapists: "Terapistler",
      psychometric: "Psikometrik Terapistler",
      assistants: "Asistanlar",
    },
    labels: {
      age: "Yaş",
      education: "Eğitim",
      workHistory: "İş Deneyimi",
    },
  },
  privacyPage: {
    header: {
      title: "Gizlilik Politikası",
      subtitle: "Verilerinizi nasıl koruduğumuzu öğrenin",
    },
  },
  navbar: {
    getToKnowUs: "Bizi Tanıyın",
    ourSpecializations: "Uzmanlık Alanlarımız",
    viewAllDepartments: "Tüm Departmanları Görüntüle",
    resources: "Kaynaklar",
    helpfulResources: "Faydalı Kaynaklar",
    about: {
      title: "Hakkımızda",
      desc: "Misyonumuz ve vizyonumuz",
    },
    process: {
      title: "Sürecimiz",
      desc: "Bilimsel danışmanlık yaklaşımımız",
    },
    team: {
      title: "Ekibimiz",
      desc: "Uzman danışman kadromuz",
    },
    deptDepression: {
      title: "Depresyon",
      desc: "Depresyonla başa çıkma desteği",
    },
    deptAnxiety: {
      title: "Kaygı ve Korku",
      desc: "Kaygı yönetimi danışmanlığı",
    },
    deptOcd: {
      title: "Takıntılar (OKB)",
      desc: "Takıntılı düşünceler için destek",
    },
    deptSleep: {
      title: "Uyku Bozuklukları",
      desc: "Sağlıklı uyku düzeni rehberliği",
    },
    deptCounseling: {
      title: "Psikolojik Danışmanlık",
      desc: "Bireysel danışmanlık desteği",
    },
    deptBehavioralSupport: {
      title: "Davranışsal Destek",
      desc: "Günlük egzersiz takibi ve motivasyon",
    },
    resKnowledge: {
      title: "Bilgi Merkezi",
      desc: "Makaleler ve rehberler",
    },
    resQuiz: {
      title: "Psikolojik Test",
      desc: "Kendinizi değerlendirin",
    },
    resFaq: {
      title: "Sık Sorulan Sorular",
      desc: "Merak edilenler",
    },
    resAi: {
      title: "Yapay Zeka Asistanı",
      desc: "7/24 AI destekli danışmanlık",
    },
  },
  footerSection: {
    quizTitle: "Kendinizi Değerlendirin",
    quizSubtitle:
      "Kısa değerlendirme sorularını yanıtlayarak mevcut durumunuza dair genel bir fikir edinin",
    startQuiz: "Teste Başla",
    company: "Kurumsal",
    aboutUs: "Hakkımızda",
    ourTeam: "Ekibimiz",
    departments: "Departmanlar",
    depression: "Depresyon",
    anxietyFear: "Kaygı ve Korku",
    ocd: "Takıntılar (OKB)",
    sleepDisorders: "Uyku Bozuklukları",
    psychotherapy: "Psikoterapi",
    psychometric: "Psikometrik Testler",
    behavioralSupport: "Davranışsal Destek",
    allDepartments: "Tüm Departmanlar",
    resources: "Kaynaklar",
    aiAssistant: "Yapay Zeka Asistanı",
    knowledgeCenter: "Bilgi Merkezi",
    mentalHealthQuiz: "Psikolojik Test",
    faq: "SSS",
    privacyPolicy: "Gizlilik Politikası",
    information: "Bilgilendirme",
    contact: "İletişim",
    whatsappContact: "WhatsApp ile İletişim",
    madeWithLove: "Sevgiyle yapıldı",
  },
  departmentsSection: {
    badge: "Uzmanlık Alanlarımız",
    title: "Size Nasıl Yardımcı Olabiliriz?",
    subtitle:
      "Deneyimli danışmanlarımız çeşitli psikolojik konularda size destek olmak için burada.",
  },
  teamSection: {
    badge: "Uzman Ekibimiz",
    title: "Profesyonel Ekibimizle Tanışın",
    subtitle: "Deneyimli ve uzman kadromuzla size en iyi hizmeti sunuyoruz.",
    therapists: "Terapist",
    supervisor: "Süpervizör",
    assistants: "Asistan",
    psychometricTherapists: "Psikometrik Terapist",
    meetTeam: "Ekibimizi Tanıyın",
  },
  certificatesSection: {
    badge: "Sertifikalarımız",
    title: "Güvenilir ve Sertifikalı",
  },
  knowledgeCenterPage: {
    dsm5Based: "DSM-5 Temelli İçerikler",
    expertTeam: "Nefes Psikoloji Uzman Ekibi",
    certifiedCounselors: "Sertifikalı Danışmanlar",
    dsm5BasedShort: "DSM-5 Temelli",
    evidenceBased: "Kanıta Dayalı",
    articles: "Makale",
    categories: "Kategori",
    reads: "Okuma",
    based: "Temelli",
    editorChoice: "Editör Seçimi",
    featuredArticles: "Öne Çıkan Makaleler",
    featuredSubtitle: "Uzman ekibimizin önerdiği en popüler içerikler",
    verified: "Onaylı",
    expertTeamBadge: "Uzman Ekip",
    preparedBy: "Nefes Uzman Ekibi Tarafından Hazırlandı",
    preparedByDesc:
      "Tüm makaleler sertifikalı psikolojik danışmanlarımız tarafından hazırlanmaktadır",
    certifiedExperts: "Sertifikalı Uzmanlar",
    scientificApproach: "Bilimsel Yaklaşım",
    trustedSource: "Güvenilir Kaynak",
    wantSupport: "Profesyonel Destek Almak İster Misiniz?",
    contactExperts: "Uzman psikolojik danışmanlarımızla hemen iletişime geçin",
    whatsappContact: "WhatsApp ile İletişime Geçin",
    freeConsultation: "Ücretsiz Ön Görüşme",
    privacyGuarantee: "Gizlilik Garantisi",
    whatsappMessage: "Merhaba, danışmanlık seansı almak istiyorum.",
  },
  faqPage: {
    helpCenter: "Yardım Merkezi",
    searchPlaceholder: "Soru ara...",
    stillHaveQuestions: "Hala sorunuz mu var?",
    teamHappy: "Ekibimiz size yardımcı olmaktan mutluluk duyar.",
    contactUs: "Bize Ulaşın",
  },
  therapistsPage: {
    trainingRegistration: "Eğitime Kayıt",
    trainingDesc:
      "Nefes Psikoloji Eğitime Kayıt için cep telefonu numaranızı girin",
    phonePlaceholder: "Telefon numarası",
    submit: "Gönder",
    phoneHint:
      "Lütfen başında ülke kodu olmadan, 10 haneli telefon numarası giriniz.",
  },
  departmentDetailsPage: {
    specialization: "Uzmanlık Alanı",
    overview: "Genel Bakış",
    symptoms: "Belirtiler",
    readyToHelp: "Yardım Almaya Hazır mısınız?",
    contactCounselors: "Uzman danışmanlarımızla hemen iletişime geçin.",
    whatsappContact: "WhatsApp ile Ulaşın",
    whyNefes: "Neden Nefes?",
    expertTeam: "Profesyonel danışmanlık",
    personalizedApproach: "Yapılandırılmış süreç",
    evidenceBasedMethods: "Etik çalışma ilkeleri",
    confidentiality: "Gizlilik odaklı yaklaşım",
    treatmentApproach: "Danışmanlık Yaklaşımımız",
    takeFirstStep: "İlk Adımı Atın",
    contactForSupport:
      "Profesyonel destek almak için bugün bizimle iletişime geçin.",
    bookAppointment: "Randevu Alın",
  },
  adminKnowledge: {
    pageTitle: "Bilgi Merkezi Yönetimi",
    pageSubtitle: "Makale, kategori ve etiket yönetimi",
    adminLogin: "Yönetici Girişi",
    enterPassword: "Devam etmek için yönetici şifrenizi girin",
    adminPassword: "Yönetici şifresi",
    login: "Giriş Yap",
    logout: "Çıkış",
    articles: "Makaleler",
    categories: "Kategoriler",
    tags: "Etiketler",
    newArticle: "Yeni Makale",
    title: "Başlık",
    category: "Kategori",
    status: "Durum",
    views: "Görüntüleme",
    date: "Tarih",
    actions: "İşlemler",
    published: "Yayında",
    draft: "Taslak",
    noArticles: "Henüz makale yok",
    newCategory: "Yeni Kategori",
    nameTr: "Ad (TR)",
    nameEn: "Ad (EN)",
    active: "Aktif",
    inactive: "Pasif",
    noCategories: "Henüz kategori yok",
    newTag: "Yeni Etiket",
    noTags: "Henüz etiket yok",
    editArticle: "Makale Düzenle",
    titleTr: "Başlık (TR)",
    titleEn: "Başlık (EN)",
    excerptTr: "Özet (TR)",
    excerptEn: "Özet (EN)",
    contentTr: "İçerik (TR)",
    contentEn: "İçerik (EN)",
    selectCategory: "Kategori seçin",
    readingTime: "Okuma Süresi (dk)",
    featuredImageUrl: "Öne Çıkan Görsel URL",
    authorName: "Yazar Adı",
    metaTitleTr: "Meta Başlık (TR)",
    metaTitleEn: "Meta Başlık (EN)",
    metaDescTr: "Meta Açıklama (TR)",
    metaDescEn: "Meta Açıklama (EN)",
    featured: "Öne Çıkan",
    publish: "Yayınla",
    cancel: "İptal",
    save: "Kaydet",
    editCategory: "Kategori Düzenle",
    descriptionTr: "Açıklama (TR)",
    descriptionEn: "Açıklama (EN)",
    confirmDeleteArticle: "Makaleyi silmek istediğinize emin misiniz?",
    confirmDeleteCategory: "Kategoriyi silmek istediğinize emin misiniz?",
    confirmDeleteTag: "Etiketi silmek istediğinize emin misiniz?",
    sessionExpired: "Oturum süresi doldu",
    failedSaveArticle: "Makale kaydedilemedi",
    failedSaveCategory: "Kategori kaydedilemedi",
    failedSaveTag: "Etiket kaydedilemedi",
  },
};
